import Cookies from 'js-cookie';

export const getCookie = (
  key: Parameters<typeof Cookies.get>[0]
): ReturnType<typeof Cookies.get> => Cookies.get(key);

export const removeCookie = (
  key: Parameters<typeof Cookies.remove>[0]
): ReturnType<typeof Cookies.remove> => Cookies.remove(key);

export const setCookie = (
  key: Parameters<typeof Cookies.set>[0],
  value: Parameters<typeof Cookies.set>[1],
  attributes?: Parameters<typeof Cookies.set>[2]
): ReturnType<typeof Cookies.set> => Cookies.set(key, value, attributes);
